import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import DateComponent from './DateComponent';
import DownloadIcon from './DownloadIcon';
import Button from './Button';
import Style from '../constants/Style';
import Colors from '../constants/Colors';
import { DateRange } from '../redux/dateRangeSlice';

interface FixedDateComponentProps {
  // eslint-disable-next-line no-unused-vars
  onConfirm: (start: string, end: string, selectedRange: any) => void;
  // eslint-disable-next-line no-unused-vars
  onCompareConfirm: (start: string, end: string, selectedRange: any) => void;
  liveEnabled?: boolean;
  showExport?: boolean;
}

const FixedDateComponent = ({
  onConfirm,
  onCompareConfirm,
  liveEnabled,
  showExport = false,
}: FixedDateComponentProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => ({
    start: state.dateRange.start,
    end: state.dateRange.end,
    selectedRange: state.dateRange.selectedRange,
  }));

  const compareRange: DateRange = useSelector((state: { dateComparisonRange: DateRange }) => ({
    start: state.dateComparisonRange.start,
    end: state.dateComparisonRange.end,
  }));

  const isDev: boolean = useSelector((state:
    { devState: { isDev: boolean } }) => state.devState.isDev);

  return (
    <View style={styles.container}>
      <View style={[Style.row, { height: 40 }]}>
        <DateComponent
          selectedRange={range.selectedRange}
          compareEnabled
          onChange={onConfirm}
          onCompareChange={onCompareConfirm}
          onOpen={() => {}}
          onConfirm={() => {}}
          startDate={range.start}
          endDate={range.end}
          compareStartDate={compareRange.start}
          compareEndDate={compareRange.end}
          liveEnabled={liveEnabled}
          renderLeft
        />
        {isDev && showExport && (
          <>
            <View style={styles.separator} />
            <Button
              title="Export"
              children={
                <DownloadIcon
                  color="#FFF"
                  style={styles.downloadIcon}
                />
              }
              style={styles.export}
              affirmative
            />
          </>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: 8,
    padding: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  separator: {
    marginHorizontal: 16,
    alignSelf: 'stretch',
    width: 1,
    backgroundColor: Colors.light.hereworksBlue100,
  },
  export: {
    height: 38,
    marginStart: 2,
  },
  downloadIcon: {
    marginStart: 8,
  },
});

export default FixedDateComponent;
